// src/index.js
import { OsanoManager } from 'appdev-ui-library';

let manager = null;
let showDrawerFn = null;

function getMetaContent(name) {
  const meta = document.querySelector(`meta[name="${name}"]`);
  return meta ? meta.content : null;
}

function wireButtons(selector) {
  if (!showDrawerFn) return;

  const buttons = document.querySelectorAll(selector);
  if (!buttons.length) {
    console.warn('[Osano] No elements found for selector:', selector);
    return;
  }

  buttons.forEach((btn) => {
    btn.addEventListener('click', () => {
      showDrawerFn?.();
    });
  });
}

function initOsanoFromConfig() {
  // Try to get the script element that loaded this bundle
  let scriptEl = document.currentScript;

  // Fallback: first script with data-osano-url
  if (!scriptEl || !scriptEl.dataset) {
    scriptEl = document.querySelector('script[data-osano-url]');
  }

  const scriptURL =
    scriptEl?.dataset?.osanoUrl || getMetaContent('osano-script-url');

  if (!scriptURL) {
    console.error(
      '[Osano] Missing script URL. Set data-osano-url on the script tag or <meta name="osano-script-url" ...>.'
    );
    return;
  }

  const enabledAttr = scriptEl?.dataset?.osanoEnabled;
  const enabled = enabledAttr === undefined ? true : enabledAttr !== 'false';

  const country = navigator.language.split('-')[1] || 'us'
  const languageCode = navigator.language.split('-')[0] || 'en'

  const primaryColor =
    scriptEl?.dataset?.osanoPrimaryColor ||
    getMetaContent('osano-primary-color') ||
    '#333';

  const buttonSelector =
    scriptEl?.dataset?.osanoButtonSelector ||
    getMetaContent('osano-button-selector') ||
    '[data-osano-open], #cookieBtn';

  if (manager) {
    console.warn('[Osano] OsanoManager is already initialized.');
    return;
  }

  manager = new OsanoManager({
    enabled,
    scriptURL,
    country,
    languageCode,
    colorPalette: { primary: primaryColor },
    cookieBannerDefault: () =>
      console.log('[Osano] Default cookie banner removed'),
    trackingHandler: (action) =>
      console.log('[Osano] Track action:', action),
    onDrawerReady: (drawerFn) => {
      showDrawerFn = drawerFn;
      wireButtons(buttonSelector);
    },
  });

  console.log('[Osano] Initialized with scriptURL:', scriptURL);
}

function destroyOsano() {
  if (manager) {
    manager.destroy();
    manager = null;
    showDrawerFn = null;
    console.log('[Osano] Destroyed');
  }
}

// Auto-init on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initOsanoFromConfig);
} else {
  initOsanoFromConfig();
}

// Optional global API
window.OsanoApp = {
  destroy: destroyOsano,
  openPreferences: () => showDrawerFn?.(),
  getManager: () => manager,
};
